export const GET_DOCS_REQUEST = 'GET_DOCS_REQUEST';
export const GET_DOCS_SUCCESS = 'GET_DOCS_SUCCESS';
export const GET_DOCS_FAILURE = 'GET_DOCS_FAILURE';

export const VIEW_DOC_REQUEST = 'VIEW_DOC_REQUEST';

export const LOAD_DOC_REQUEST = 'LOAD_DOC_REQUEST';
export const LOAD_DOC_SUCCESS = 'LOAD_DOC_SUCCESS';
export const LOAD_DOC_FAILURE = 'LOAD_DOC_FAILURE';
